var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForesightNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 32,
    viewBox: "0 0 105 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_111011)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_392_111011)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8471 24.8471 32 16 32C7.15294 32 0 24.8471 0 16C0 7.15294 7.15294 0 16 0C24.8471 0 32 7.15294 32 16Z",
    fill: "#002FA7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 15.9296L24.0228 7.95312H16.917L20.4699 11.4825L30.8698 21.8825C31.5992 20.0472 31.9993 18.0708 31.9993 15.9767C31.9993 15.9767 31.9993 15.9531 31.9993 15.9296Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 7,
    width: 5,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4707 11.4825L24.0236 15.0355V7.95312L20.4707 11.4825Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0236 7.95312H20.4707V15.059H24.0236V7.95312Z",
    fill: "url(#paint0_linear_392_111011)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9174 7.95322L10.8232 14.0473L14.3762 17.6003L20.4703 11.4826L24.0232 7.92969C21.2468 7.95322 19.6938 7.95322 16.9174 7.95322Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 7,
    width: 10,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9335 7.94336L11.127 13.7499L14.6708 17.2938L20.4774 11.4872L16.9335 7.94336Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_392_111011)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 7,
    width: 10,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4711 7.95312H11.1299V17.2943H20.4711V7.95312Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5554 7.83105H11.0684V17.3181H20.5554V7.83105Z",
    fill: "url(#pattern0_392_111011)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 13.2941L11.6467 16.847L20.5408 25.7411L24.0937 22.1882L15.1996 13.2941H8.09375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 5,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 16.8469L15.2004 20.3998V13.2939L11.6475 16.8469Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2004 13.2939H11.6475V20.3998H15.2004V13.2939Z",
    fill: "url(#paint1_linear_392_111011)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 13.2941H8.09429L0.706055 20.7058C1.2237 22.3999 2.04723 23.9999 3.059 25.4117L11.6237 16.847L15.2002 13.2941Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5404 14.3527H98.0228V10.2351C98.0228 8.8939 97.5522 8.07037 96.5875 7.74096C96.3522 7.64684 96.0933 7.62331 95.811 7.62331C94.9404 7.62331 94.2581 7.95272 93.7404 8.61155C93.6228 8.75272 93.5522 8.91743 93.4581 9.05861V4.30566H90.4698V4.70566H91.411V13.5057C91.411 13.9998 91.1757 14.2821 90.6816 14.3292C90.611 14.3292 90.5404 14.3527 90.4463 14.3527V14.7763H94.2345C94.2345 14.541 94.0463 14.3527 93.811 14.3527H93.4345V10.4939C93.4345 9.55272 93.7169 8.91743 94.3051 8.61155C94.4933 8.51743 94.658 8.47037 94.8463 8.47037C95.5051 8.47037 95.8581 8.87037 95.9522 9.67037C95.9522 9.76449 95.9757 9.85861 95.9757 9.95272V13.5057C95.9757 13.9292 95.9051 14.188 95.7875 14.2586C95.6698 14.3057 95.5286 14.3292 95.3639 14.3292V14.7527H98.9639C98.9639 14.541 98.7757 14.3527 98.5404 14.3527Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.518 13.0115C104.306 13.8821 103.977 14.3527 103.577 14.4468C103.506 14.4468 103.459 14.4703 103.388 14.4703C102.988 14.4703 102.753 14.188 102.659 13.6233C102.635 13.5056 102.635 13.3644 102.635 13.2233V8.35267H104.753V7.92914H102.635V6.07031L100.588 6.39972V7.92914H99.4824V8.35267H100.588V12.3762C100.588 13.9291 101.224 14.7997 102.518 14.9409C102.635 14.9409 102.777 14.9644 102.894 14.9644C103.718 14.9644 104.282 14.7056 104.612 14.1644C104.753 13.9056 104.871 13.5527 104.965 13.1056L104.518 13.0115Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3993 7.71751C90.3993 7.34104 90.1875 7.03516 89.811 6.87045C89.6463 6.79987 89.4581 6.75281 89.2463 6.75281C88.6816 6.75281 88.2581 7.08222 87.9522 7.71751C87.9052 7.83516 87.8581 7.95281 87.811 8.07045C87.2934 7.74104 86.6581 7.57634 85.9052 7.57634C84.6581 7.57634 83.7405 7.97634 83.1758 8.77634C82.8463 9.2234 82.6816 9.71751 82.6816 10.2587C82.6816 11.0352 83.0581 11.7175 83.811 12.2822C83.9522 12.3999 84.0934 12.494 84.2581 12.5646H84.2346C83.5993 12.5646 83.1522 12.8234 82.9169 13.4116C82.8228 13.6234 82.7993 13.8352 82.7993 14.0469C82.7993 14.5646 83.0111 14.9881 83.3875 15.294C83.1052 15.6234 82.964 15.9528 82.964 16.2822C82.964 16.8705 83.3405 17.294 84.1169 17.5763C84.6346 17.7646 85.2463 17.8587 85.9758 17.8587C87.7405 17.8587 88.8699 17.4352 89.3875 16.6116C89.5522 16.3528 89.6228 16.094 89.6228 15.8116C89.6228 14.7293 89.0346 14.1175 87.8581 13.9528C87.7169 13.9293 87.5758 13.9293 87.4346 13.9293L84.0934 13.8587C83.8111 13.8587 83.6463 13.7175 83.5993 13.4822C83.5993 13.4587 83.5758 13.4116 83.5758 13.3881C83.5758 13.1528 83.7169 13.0116 83.9758 12.9646C84.0228 12.9646 84.0699 12.941 84.0934 12.941L85.811 12.9646C86.9875 12.9646 87.8816 12.5646 88.4934 11.7646C88.8463 11.294 89.0111 10.7763 89.0111 10.1881C89.0111 9.41163 88.7052 8.75281 88.1169 8.25869C88.3052 7.95281 88.5405 7.81163 88.7993 7.7881C88.9405 7.7881 89.1052 7.88222 89.3169 8.07045C89.3875 8.14104 89.4816 8.1881 89.5522 8.21163C89.6228 8.23516 89.7169 8.25869 89.7875 8.25869C89.8581 8.25869 89.9287 8.23516 89.9758 8.23516C90.0228 8.21163 90.0699 8.1881 90.1169 8.16457C90.1405 8.16457 90.1405 8.14104 90.164 8.11751C90.3052 8.07045 90.3993 7.90575 90.3993 7.71751ZM83.764 15.5763C83.9758 15.6705 84.2111 15.694 84.4463 15.694L87.6934 15.7175C88.3052 15.7175 88.6816 15.8116 88.7993 15.9999C88.8463 16.0705 88.8699 16.1646 88.8699 16.2822C88.8699 16.7763 88.3758 17.1293 87.364 17.341C86.9405 17.4352 86.4934 17.4587 85.9758 17.4587C84.6581 17.4587 83.8816 17.1763 83.5993 16.5881C83.5522 16.4705 83.5287 16.3528 83.5287 16.2352C83.5287 16.0234 83.5993 15.8116 83.764 15.5763ZM86.8934 11.5999C86.8934 12.1646 86.4463 12.6116 85.8816 12.6116H85.7169C85.1522 12.6116 84.7052 12.1646 84.7052 11.5999V9.01163C84.7052 8.44692 85.1522 7.99987 85.7169 7.99987H85.8816C86.4463 7.99987 86.8934 8.44692 86.8934 9.01163V11.5999Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9178 14.329H43.0119V10.0466H46.1178V9.55253H43.0119V5.529H44.8237C45.7884 5.529 46.4237 6.02312 46.7531 7.03488L46.7766 7.05841L47.1296 8.25841H47.6002L47.5296 5.10547H39.459V5.529H40.7531V14.329H39.459V14.7761H44.9178V14.329Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5417 14.3532H59.3887V10.8708C59.4593 9.74139 59.7417 9.05904 60.2122 8.80022C60.2828 8.77669 60.5417 8.63551 60.8005 9.12963C60.9887 9.48257 61.2005 9.69434 61.4358 9.76492C61.5534 9.78845 61.6711 9.81198 61.7887 9.81198C62.2122 9.81198 62.5181 9.60022 62.7064 9.20022C62.777 9.05904 62.8005 8.91787 62.8005 8.75316C62.8005 8.21198 62.5417 7.88257 62.0005 7.74139C61.8828 7.71787 61.7417 7.69434 61.6005 7.69434C60.9417 7.69434 60.3534 7.95316 59.8358 8.49434C59.6005 8.75316 59.4358 9.03551 59.3181 9.34139L59.2005 7.83551H56.377V8.25904H57.3181V13.5061C57.3181 13.9767 57.1299 14.259 56.7534 14.3061C56.6358 14.3296 56.5181 14.3296 56.377 14.3296V14.7532H60.9417C60.9417 14.5414 60.7534 14.3532 60.5417 14.3532Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9772 13.1065L69.6007 12.9888C69.2948 13.6476 68.8242 14.0947 68.189 14.33C67.9301 14.4241 67.6713 14.4712 67.389 14.4712C66.5184 14.4712 65.9772 13.93 65.7184 12.8241C65.6242 12.3771 65.5772 11.8359 65.5537 11.2006L67.036 11.2476C68.7772 11.2947 69.7654 11.0359 70.0478 10.4241C70.1184 10.2829 70.1419 10.1182 70.1419 9.93C70.1419 9.01235 69.6713 8.35353 68.7301 7.93C68.2125 7.6947 67.6007 7.60059 66.9419 7.60059C65.7184 7.60059 64.7772 8.02412 64.0948 8.84764C63.5772 9.48294 63.3184 10.2829 63.3184 11.2476C63.3184 12.8006 63.9066 13.8829 65.0831 14.4947C65.6478 14.7771 66.2831 14.9418 66.9889 14.9418C68.236 14.9418 69.1537 14.4947 69.6948 13.6241C69.836 13.4594 69.9066 13.2947 69.9772 13.1065ZM66.9654 8.02412C67.6478 8.04764 68.0007 8.63588 68.0242 9.78882C68.0242 10.2829 67.8831 10.6124 67.5772 10.73C67.3654 10.8006 67.036 10.8241 66.6125 10.8006L65.5772 10.7535C65.6478 8.96529 66.0948 8.04764 66.9654 8.02412Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6591 10.5177C74.3532 10.4001 74.1415 10.2824 74.0238 10.2118C73.3885 9.88242 73.0591 9.50595 73.0591 9.03536C73.0591 8.91772 73.0826 8.8236 73.1062 8.70595C73.2709 8.25889 73.6944 8.0236 74.3768 8.0236C75.3885 8.0236 75.9297 8.51772 75.9768 9.50595H76.4944V7.48242C76.2591 7.48242 76.0709 7.67066 76.0709 7.90595V8.0236C75.6003 7.71772 74.9415 7.57654 74.0944 7.57654C73.5768 7.57654 73.1062 7.64713 72.6826 7.7883C71.6944 8.11772 71.1768 8.72948 71.1768 9.64713C71.1768 10.0942 71.3179 10.4707 71.6003 10.8001C71.8591 11.106 72.4003 11.4354 73.2003 11.7883C73.5297 11.9295 73.765 12.0471 73.9297 12.1177C74.6121 12.4942 74.965 12.9412 74.965 13.4824C74.965 13.553 74.965 13.6236 74.9415 13.6942C74.8238 14.2118 74.4238 14.4707 73.6944 14.4707C72.4238 14.4707 71.765 13.7883 71.7415 12.4707H71.2003V14.9177C71.4356 14.9177 71.6473 14.7295 71.6473 14.4942V14.4236C72.2826 14.753 73.0826 14.9177 74.0238 14.9177C74.5179 14.9177 74.965 14.8471 75.365 14.7295C76.3297 14.4001 76.8238 13.7883 76.8238 12.8471C76.8238 12.353 76.6591 11.906 76.3297 11.553C76.0473 11.2471 75.4826 10.8942 74.6591 10.5177Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2473 14.3536H80.6826V7.83594H77.6943V8.25947H78.6355V13.5065C78.6355 13.9771 78.4473 14.2595 78.0708 14.3065C77.9532 14.3301 77.8355 14.3301 77.6943 14.3301V14.7536H81.6708C81.6708 14.5418 81.4826 14.3536 81.2473 14.3536Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5171 18.3064H47.8112V24.5416L42.1171 17.8594H39.3877V18.2829H40.6818V27.0828H39.3877V27.5063H42.7289C42.7289 27.271 42.5406 27.0828 42.3053 27.0828H41.3642V20.377L47.5759 27.624H48.4936V18.3064H49.7877V17.8829H46.5406V18.3064H46.5171Z",
    fill: "#002FA7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7409 20.7054C55.2232 20.4701 54.6115 20.376 53.9526 20.376C52.7291 20.376 51.7879 20.7995 51.1056 21.623C50.5879 22.2583 50.3291 23.0583 50.3291 24.0231C50.3291 25.5761 50.9173 26.6584 52.0938 27.2702C52.6585 27.5525 53.2938 27.6937 53.9997 27.6937C55.2467 27.6937 56.1644 27.2467 56.7056 26.3761C56.8232 26.2114 56.8938 26.0467 56.9644 25.882L56.5879 25.7643C56.282 26.4231 55.8115 26.8702 55.1762 27.1055C54.9173 27.1996 54.6585 27.2467 54.3762 27.2467C53.5056 27.2467 52.9644 26.7055 52.7056 25.5996C52.6115 25.1525 52.5644 24.6114 52.5409 23.9761L54.0232 24.0231C55.7644 24.0702 56.7526 23.8114 57.035 23.1995C57.1056 23.0583 57.1291 22.8936 57.1291 22.7054C57.1291 21.7877 56.6585 21.1289 55.7409 20.7054ZM54.5409 23.4819C54.3291 23.5525 53.9997 23.5761 53.5762 23.5525L52.5409 23.5054C52.6115 21.7172 53.082 20.823 53.9526 20.776C54.635 20.7995 54.9879 21.3877 55.0115 22.5407C54.9879 23.0583 54.8468 23.3642 54.5409 23.4819Z",
    fill: "#002FA7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0829 23.2941C72.7771 23.1764 72.5653 23.0588 72.4476 22.9882C71.8124 22.6588 71.4829 22.2823 71.4829 21.8117C71.4829 21.6941 71.5065 21.6 71.53 21.4823C71.6947 21.0353 72.1182 20.8 72.8006 20.8C73.8124 20.8 74.3535 21.2941 74.4006 22.2823H74.9182V20.2588C74.6829 20.2588 74.4947 20.447 74.4947 20.6823V20.8C74.0241 20.4941 73.3653 20.3529 72.5182 20.3529C72.0006 20.3529 71.53 20.4235 71.1065 20.5647C70.1182 20.8941 69.6006 21.5058 69.6006 22.4235C69.6006 22.8706 69.7418 23.247 70.0241 23.5765C70.2829 23.8824 70.8241 24.2118 71.6241 24.5648C71.9535 24.7059 72.1888 24.8236 72.3535 24.8942C73.0359 25.2706 73.3888 25.7177 73.3888 26.2589C73.3888 26.3295 73.3888 26.4001 73.3653 26.4706C73.2476 26.9883 72.8476 27.2471 72.1182 27.2471C70.8476 27.2471 70.1888 26.5648 70.1653 25.2471H69.6241V27.6942C69.8594 27.6942 70.0712 27.5059 70.0712 27.2471V27.1765C70.7065 27.5059 71.5065 27.6706 72.4476 27.6706C72.9418 27.6706 73.3888 27.6001 73.7888 27.4824C74.7535 27.153 75.2476 26.5412 75.2476 25.6001C75.2476 25.1059 75.0829 24.6589 74.7535 24.2824C74.4712 24.0001 73.9065 23.6706 73.0829 23.2941Z",
    fill: "#002FA7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1173 20.6113H66.6585V21.0349H67.6468L66.1409 25.7408L64.5644 21.0349H65.5291V20.6113H62.3997L62.9409 22.2349L61.8821 25.7408L60.3291 21.0584H61.2938V20.6349H57.5762V21.0584H58.2585L60.1173 26.4702C60.3526 27.1055 60.5644 27.482 60.7997 27.5761C60.9173 27.6232 61.035 27.6467 61.1997 27.6467H61.7409L63.2468 22.9878L64.4468 26.4702C64.6585 27.082 64.8468 27.435 64.9879 27.5291C65.1056 27.5997 65.2703 27.6467 65.4821 27.6467H66.0232L68.0468 21.529C68.1409 21.2231 68.3291 21.0819 68.5879 21.0584C68.7997 21.0584 68.9879 20.8702 68.9879 20.6349H68.1173C68.1173 20.6113 68.1173 20.6113 68.1173 20.6113Z",
    fill: "#002FA7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8238 5.71746C80.8238 6.37628 80.2827 6.91746 79.6238 6.91746C78.965 6.91746 78.4238 6.37628 78.4238 5.71746C78.4238 5.05863 78.965 4.51746 79.6238 4.51746C80.2827 4.51746 80.8238 5.05863 80.8238 5.71746Z",
    fill: "#231815"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_392_111011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 32
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 0H0V32H104.941V0Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_392_111011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3063 8.35353C53.6475 7.85941 52.871 7.60059 51.9298 7.60059C50.6122 7.60059 49.6004 8.04764 48.8945 8.96529C48.4004 9.60059 48.1416 10.3535 48.1416 11.2241C48.1416 12.4476 48.5651 13.3888 49.3887 14.1182C50.0475 14.6829 50.8475 14.9653 51.7651 14.9653C53.0357 14.9653 54.024 14.5182 54.7534 13.6006C55.2945 12.9182 55.5534 12.1182 55.5534 11.2241C55.5769 9.97706 55.1534 9.03588 54.3063 8.35353ZM53.3651 13.1535C53.3651 13.93 52.7298 14.5653 51.9534 14.5653H51.7651C50.9887 14.5653 50.3534 13.93 50.3534 13.1535V9.45941C50.3534 8.68294 50.9887 8.04765 51.7651 8.04765H51.9534C52.7298 8.04765 53.3651 8.68294 53.3651 9.45941V13.1535Z",
    fill: "#231815"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_392_111011",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_392_111011",
    transform: "scale(0.0117647)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_392_111011",
    x1: 20.4911,
    y1: 11.4897,
    x2: 23.9989,
    y2: 11.4897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_392_111011",
    x1: 11.6767,
    y1: 16.8431,
    x2: 15.1601,
    y2: 16.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_111011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.941,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_392_111011",
    width: 85,
    height: 85,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAKBAAADNgAABEX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAFUAVQMBIgACEQEDEQH/xACqAAEAAgMBAQAAAAAAAAAAAAAABAUBAgMHBgEAAgMBAAAAAAAAAAAAAAAAAAIBAwQFEAACAgEDAwQDAQAAAAAAAAAAAgEDBBARBSAhEjAxIjITFQYzEQABAgIHBAYLAQAAAAAAAAABAgMAERAgITFBEgQwUZEiYaEyshNzcYHB0UJiIzNjFDQVEgABAgUDBQAAAAAAAAAAAAABEDEgEYECMgAhcTBhocFC/9oADAMBAAIRAxEAAAD0AANQ2YBkAAAArZiVmvkuszPHojbtcxOWMgAUcCJruzWsmo7q1x2qe9TWW8Dujy9o/VJ3YRPwfHWJ1sVj1qtwuZFJIra7k0syl7eRXW9FuzZU/nlN6p5r08sPMTGuqwk1EhS6sqX0DHd1kGDSECtGjybmd7Jt2CPR/oDh6wrYA//aAAgBAgABBQDqVZmZXYmOha4hWQlCVJjRV+MoNWMg+0aYt8PHiMhkOqRMzMlf3j2ku/00/9oACAEDAAEFAOqZiCGN+iWmZhiGIk30me+5DEML30srlZ2IK1liI20b2JE+un//2gAIAQEAAQUA9bf0rL4mVYifQy+QWWrsEsEsIc8jfo5XlvnXaV3CXCXC2kWEOROudZtnpaJcJeJeJeJcLYK5DG/bkX25GLRbhLxMgS8rvK7hLCtpafHtyj7cn+Ui4W8TIK8grvKrjGl7XqqipT+jwcnC5GbCbSLhLyu8qvMFbcm3ExExatM7Bxs/G53h8rh8mXPMSwrtOOoyM7I4zjaeOo6Of/V/q7orizuLuJ5H8hHFRgdH/9oACAECAgY/AItohKIcCIWHa4eVk9xYamUtycY5U0PaXZP9uv8A/9oACAEDAgY/AOoZxHmKYYr2UtVlDUX/2gAIAQEBBj8A21myypNmJ2RaZMwLFLGPQNkrSMGQSSl1fSL0jZ6nznO8ab4vi+tqx+ZzvGm+L4vqSESjWee73zUvi+kIQJkxIWnE0POOp+lqHFuNLHZIUc0vSJ21b6EtMjMo8AN5gITao9te80r02pTmbXxScFJOBEeE7zsrmWXgLFj2EYiqnT6dOZxXADFSjgBAbRzOK+44b1H3VXv9X+aWHbz/AA+H827rsnCgyVKamchWAlRThMAqAPrqEaElT9n7JcAS4ThYCrl3W9c6v//Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForesightNews);
export default __webpack_public_path__ + "static/media/foresight-news.261e66fd4c3a516b29102c489170e0a3.svg";
export { ForwardRef as ReactComponent };